import { getOrgConfig } from "../../../utils/organizationConfigUtil";

export default function Footer() {
  const imageSrc = getOrgConfig()?.logo;
  const altText = getOrgConfig()?.companyName;
  const copyRightText = getOrgConfig()?.labels?.copyRightText;
  const nmlsText = getOrgConfig()?.labels?.nmlsText;
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src={imageSrc}
              alt={altText}
              width={180}
              height={54}
              className="h-10 w-auto brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Empowering mortgage professionals with innovative lending solutions and exceptional service.
            </p>
            <div className="text-sm text-gray-400">
              <p>{nmlsText}</p>
              <p>Equal Housing Lender</p>
            </div>
          </div>

          {/* Loan Products */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Loan Products</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/products/conventional" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Conventional Loans
                </a>
              </li>
              <li>
                <a href="/products/non-qm" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Non-QM Loans
                </a>
              </li>
              <li>
                <a href="/products/jumbo" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Jumbo Loans
                </a>
              </li>
              <li>
                <a href="/products/investment" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Investment Property
                </a>
              </li>
              <li>
                <a href="/products/cdfi" className="text-gray-300 hover:text-brand-accent transition-colors">
                  CDFI Programs
                </a>
              </li>
            </ul>
          </div>

          {/* Broker Resources */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Broker Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/resources/rate-sheets" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Rate Sheets
                </a>
              </li>
              <li>
                <a href="/resources/guidelines" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Loan Guidelines
                </a>
              </li>
              <li>
                <a href="/resources/forms" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Forms & Documents
                </a>
              </li>
              <li>
                <a href="/resources/training" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Training Materials
                </a>
              </li>
              <li>
                <a href="/resources/marketing" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Marketing Tools
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact & Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/contact" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/support" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Customer Support
                </a>
              </li>
              <li>
                <a href="/partner" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Partner With Us
                </a>
              </li>
              <li>
                <a href="/careers" className="text-gray-300 hover:text-brand-accent transition-colors">
                  Careers
                </a>
              </li>
              <li className="text-gray-300">Phone: (555) 123-4567</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              Â© {new Date().getFullYear()} {copyRightText}
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy" className="text-gray-400 hover:text-brand-accent transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="text-gray-400 hover:text-brand-accent transition-colors">
                Terms of Service
              </a>
              <a href="/compliance" className="text-gray-400 hover:text-brand-accent transition-colors">
                Compliance
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
